export default __webpack_public_path__ + "static/media/kitchen-LC-shape-info.83524f0f.png";